import LegalPage from "../components/LegalPage";

function TermsOfService() {
  return (
    <LegalPage
      title="Terms of Service"
      updated="April 27, 2026"
      alternate={{ to: "/privacy", label: "Privacy Policy" }}
    >
      <p>
        Welcome to The Way 5:23 (“Company,” “we,” “our,” or “us”). These Terms
        of Service (“Terms”) govern your use of our mobile application and
        related services (the “Service”). By accessing or using the Service, you
        agree to be bound by these Terms.
      </p>

      <h2>1. Our Relationship</h2>
      <p>
        The Way 5:23 is a digital tool designed to support spiritual formation
        and holistic growth (Spirit, Soul, and Body).
      </p>
      <p>We are not:</p>
      <ul>
        <li>A church</li>
        <li>A licensed medical provider</li>
        <li>A mental health provider</li>
        <li>A crisis counseling service</li>
      </ul>
      <p>
        The Service is intended as a supplemental spiritual tool, not a
        substitute for professional, pastoral, or medical guidance.
      </p>

      <h2>2. Eligibility</h2>
      <p>
        You must be at least 18 years old to use the Service. By using the
        Service, you represent that you meet this requirement. We do not
        knowingly collect or solicit data from individuals under 18.
      </p>

      <h2>3. Account Responsibility</h2>
      <p>
        You agree to provide accurate information and maintain the
        confidentiality of your login credentials and Sanctuary PIN. You are
        responsible for all activity under your account.
      </p>

      <h2>4. Acceptable Use</h2>
      <p>
        You agree not to use the Service for unlawful purposes, store illegal
        content, or harass others through features such as Barnabas Support. We
        reserve the right to suspend accounts for violations.
      </p>

      <h2>5. Usage Limits and Stewardship</h2>
      <p>
        To promote healthy engagement and prevent digital addiction, daily usage
        limits apply to journaling and AI-assisted features (The Bridge). Limits
        vary by subscription tier and are an intentional part of the Service
        design.
      </p>

      <h2>6. Subscriptions and Payments</h2>
      <p>
        Certain features require a paid subscription (“Premium”).
      </p>
      <ul>
        <li>
          <strong>Billing:</strong> Handled through the Apple App Store or
          Google Play Store.
        </li>
        <li>
          <strong>Cancellations:</strong> You may cancel anytime through your
          device settings. Access continues through the end of the billing
          cycle.
        </li>
        <li>
          <strong>Refunds:</strong> Subject to the policies of Apple or Google.
        </li>
      </ul>

      <h2>7. AI-Generated Content Disclaimer</h2>
      <p>
        The Service includes AI-assisted features (“The Bridge”). You
        acknowledge that AI-generated content is informational and reflective
        only; it may contain errors and is not authoritative spiritual or
        psychological guidance. Use discernment and evaluate all content against
        Scripture.
      </p>

      <h2>8. Health and Crisis Disclaimer</h2>
      <p>
        The Service does not provide medical advice or crisis intervention. If
        you are experiencing an emergency, contact a licensed professional
        immediately.
      </p>
      <ul>
        <li>
          <strong>United States:</strong> Dial or text 988 (Suicide and Crisis
          Lifeline)
        </li>
        <li>
          <strong>Emergency:</strong> Call 911 or your local emergency number.
        </li>
      </ul>

      <h2>9. Intellectual Property</h2>
      <p>
        All content, features, and systems (including the Growth Tree and app
        design) are owned by The Way 5:23 LLC. You may not copy or redistribute
        proprietary systems without permission.
      </p>

      <h2>10. Limitation of Liability</h2>
      <p>
        The Service is provided “as is.” To the fullest extent permitted by law,
        our total liability is limited to the amount paid by you in the past 12
        months.
      </p>

      <h2>11. Governing Law</h2>
      <p>
        These Terms are governed by the laws of the State of North Carolina,
        USA. Disputes will be resolved through binding arbitration.
      </p>

      <h2>12. Contact Information</h2>
      <p>
        For questions about these Terms:{" "}
        <a href="mailto:info@theway523.com">info@theway523.com</a>
      </p>
    </LegalPage>
  );
}

export default TermsOfService;
